import React from 'react'
import { Button, Card, Box, Typography } from '@paintscout/ui'
import sherwinWilliamsLogoImage from 'src/public/images/sherwin-williams-logo.png'
import { useSherwinTrialOverDashboard } from '../useSherwinTrialOverDashboard'
import CouponBackgroundSVG from '../../shared/svgs/CouponBackgroundSVG'
import { useSherwinTrialOverDashboardMobileLayoutStyles } from './useSherwinTrialOverDashboardMobileLayoutStyles'

export default function SherwinTrialOverDashboardMobile() {
  const classes = useSherwinTrialOverDashboardMobileLayoutStyles()
  const { isAdmin, handleSelectPlan } = useSherwinTrialOverDashboard()

  return (
    <div className={classes.root}>
      <div className={classes.leftSection}>
        <Typography className={classes.heading}>
          <span className={classes.headingFirstLine}>
            <span className={classes.headingHighlight}>Your PaintScout trial is over,</span>
          </span>
          <span className={classes.headingSecondLine}>but it doesn&lsquo;t have to end here.</span>
        </Typography>
        <Typography className={classes.description}>
          Sign up for a subscription to get your $100 Sherwin-Williams coupon.
        </Typography>
        {isAdmin && (
          <Button
            variant="contained"
            color="primary"
            size="medium"
            onClick={handleSelectPlan}
            className={classes.button}
          >
            Select Plan
          </Button>
        )}
      </div>
      <div className={classes.whiteBackground}>
        <div className={classes.rightSection}>
          <div className={classes.couponContainer}>
            <div className={classes.couponBackground}>
              <CouponBackgroundSVG />
            </div>
            <Card className={classes.couponCard}>
              <div className={classes.sherwinLogo}>
                <img src={sherwinWilliamsLogoImage} alt="Sherwin-Williams" className={classes.logoImage} />
              </div>
              <Box className={classes.couponContent}>
                <Typography className={classes.couponAmount}>$100</Typography>
                <Typography className={classes.couponLabel}>Coupon</Typography>
              </Box>
            </Card>
          </div>
        </div>
      </div>
    </div>
  )
}
